import { Box, Typography } from "@mui/material";
import { readinessColor, THEME } from "./boardStyles";
import type { BoardShow } from "./boardTypes";

type Props = {
  show: BoardShow;
  /** Shows "9/14 crew" next to the percent. */
  withCrew?: boolean;
  /** Shows "80%" next to the bar. */
  withPercent?: boolean;
  height?: number;
};

/** Thin progress bar + "80%" (readiness is computed by the API). */
export default function ReadinessBar({ show, withCrew = true, withPercent = true, height = 6 }: Props) {
  const { percent, crew } = show.readiness;
  const color = readinessColor(show);
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <Box
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Show readiness"
        sx={{
          flex: 1,
          height,
          borderRadius: height,
          background: "rgba(255,255,255,0.15)",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            width: `${Math.max(2, percent)}%`,
            height: "100%",
            borderRadius: height,
            background: color,
            transition: "width 300ms ease",
          }}
        />
      </Box>
      {withPercent ? (
        <Typography sx={{ fontSize: "14px", fontWeight: 600, color, minWidth: 38, textAlign: "right" }}>
          {percent}%
        </Typography>
      ) : null}
      {withCrew ? (
        <Typography sx={{ fontSize: "14px", color: THEME.muted, whiteSpace: "nowrap" }}>
          {crew.total ? `${crew.filled}/${crew.total} crew` : "no crew yet"}
        </Typography>
      ) : null}
    </Box>
  );
}
